import React, { useState } from "react";
import { WebLink, SiteWide, Images } from "./customComponents";
import { useNavigate } from 'react-router-dom';

import { authActions } from '../redux/actions';
import Helper1, { notify } from '../utility/Helper1';
import APIRequests from '../utility/APIRequests';
import Countdown from 'react-countdown';
import { userSelect, allRemoteSettingsSelect } from '../redux/selectors/index';
import { useSelector, useDispatch } from 'react-redux';

import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import KeyIcon from "@mui/icons-material/Key";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function ForgetPassword() {
    const [emailInput, setEmailInput] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [emailCode, setEmailCode] = useState('');
    const [requestOTPRetObj, setRequestOTPRetObj] = useState({});
    const [uiLevel, setUiLevel] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [focused, setFocused] = useState(null);

    const site_settings = useSelector(allRemoteSettingsSelect);
    const navigate = useNavigate();

    const requestOTP = async (e) => {
        e.preventDefault();
        setLoading(true);
        let loadApi = new APIRequests;
        let getPost = await loadApi.runPost("account/reset_password_pin", { email: emailInput });
        if (getPost?.code == 1) {
            setUiLevel(1);
            setRequestOTPRetObj(getPost?.data);
        }
        notify(getPost?.msg, getPost?.code);
        setLoading(false);
    };

    const changePassword = async (e) => {
        e.preventDefault();
        if ((newPassword != confirmNewPassword) || (newPassword == '')) {
            notify("Passwords must match", 0);
            return;
        }
        setLoading(true);
        let loadApi = new APIRequests;
        let getPost = await loadApi.runPost("account/reset_password", {
            email: emailInput, password: newPassword, passwordResetCode: emailCode
        });
        if (getPost?.code == 1) {
            setUiLevel(2);
            setTimeout(() => { navigate('/signin'); }, 3000);
        } else {
            notify(getPost?.msg, getPost?.code);
        }
        setLoading(false);
    };

    // ── shared input style ──────────────────────────────────────────────────
    const inputStyle = (field) => ({
        width: "100%",
        borderRadius: 12,
        padding: "13px 14px 13px 42px",
        border: `1.5px solid ${focused === field ? "#2563eb" : "rgba(59,130,246,0.18)"}`,
        background: focused === field ? "#f0f7ff" : "#f8fafc",
        color: "#0f172a",
        fontSize: 14,
        fontFamily: "'DM Sans',sans-serif",
        outline: "none",
        boxSizing: "border-box",
        transition: "all 0.2s",
        boxShadow: focused === field ? "0 0 0 3px rgba(59,130,246,0.1)" : "none"
    });

    const iconStyle = (field) => ({
        position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)",
        color: focused === field ? "#2563eb" : "#94a3b8", fontSize: 18,
        transition: "color 0.2s", pointerEvents: "none"
    });

    const labelStyle = { color: "#334155", fontSize: 12, fontWeight: 600, display: "block", marginBottom: 6 };

    // Steps indicator data
    const steps = [
        { label: "Enter Email", active: uiLevel === 0, done: uiLevel > 0 },
        { label: "Reset Password", active: uiLevel === 1, done: uiLevel > 1 },
        { label: "Done", active: uiLevel === 2, done: false },
    ];

    return (
        <SiteWide>
            <div style={{
                minHeight: "100vh", display: "flex", alignItems: "stretch",
                background: "#f8fafc", fontFamily: "'DM Sans',sans-serif"
            }}>

                {/* ── Left panel ── */}
                <div style={{
                    flex: "0 0 42%", position: "relative", overflow: "hidden",
                    background: "linear-gradient(150deg,#0f172a 0%,#164e63 35%,#0e7490 70%,#0891b2 100%)",
                    display: "flex", flexDirection: "column",
                    padding: "48px 40px", boxSizing: "border-box"
                }}
                    className="auth-left-panel"
                >
                    <div style={{
                        position: "absolute", top: -60, right: -60, width: 280, height: 280,
                        borderRadius: "50%", background: "rgba(34,211,238,0.12)", filter: "blur(60px)"
                    }} />
                    <div style={{
                        position: "absolute", bottom: 40, left: -40, width: 240, height: 240,
                        borderRadius: "50%", background: "rgba(99,102,241,0.1)", filter: "blur(60px)"
                    }} />

                    {/* Logo */}
                    <div style={{ position: "relative", zIndex: 1, marginBottom: "auto" }}>
                        <Images height="44px" src={site_settings?.site_settings?.logo} alt="logo"
                            style={{ filter: "brightness(0) invert(1)" }} />
                    </div>

                    {/* Hero */}
                    <div style={{ position: "relative", zIndex: 1, marginBottom: 48 }}>
                        <h1 style={{
                            color: "#ffffff", fontSize: 36, fontWeight: 800,
                            fontFamily: "'Syne',sans-serif", lineHeight: 1.2, margin: "0 0 12px"
                        }}>
                            Get back<br />
                            to the<br />
                            <span style={{ color: "#67e8f9" }}>conversation.</span>
                        </h1>
                        <p style={{ color: "rgba(207,250,254,0.6)", fontSize: 14, margin: 0, lineHeight: 1.6 }}>
                            Reset your password quickly and securely so you can get back to chatting with your community.
                        </p>
                    </div>

                    {/* Steps visual */}
                    <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: 14 }}>
                        {[
                            { icon: <MailOutlineIcon style={{ fontSize: 18 }} />, text: "Enter your email address" },
                            { icon: <MarkEmailReadIcon style={{ fontSize: 18 }} />, text: "Check your inbox for OTP code" },
                            { icon: <LockOutlinedIcon style={{ fontSize: 18 }} />, text: "Set a new strong password" },
                        ].map((s, i) => (
                            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                <div style={{
                                    width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                                    background: "rgba(255,255,255,0.09)", backdropFilter: "blur(8px)",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    display: "flex", alignItems: "center", justifyContent: "center", color: "#67e8f9"
                                }}>
                                    {s.icon}
                                </div>
                                <span style={{ color: "rgba(207,250,254,0.7)", fontSize: 13 }}>{s.text}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ── Right panel ── */}
                <div style={{
                    flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
                    padding: "40px 24px", overflowY: "auto"
                }}>
                    <div style={{ width: "100%", maxWidth: 400 }}>

                        {/* Steps indicator */}
                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 32 }}>
                            {steps.map((s, i) => (
                                <React.Fragment key={i}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                        <div style={{
                                            width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
                                            background: s.done ? "#22c55e" : s.active ? "#2563eb" : "rgba(59,130,246,0.1)",
                                            border: `2px solid ${s.done ? "#22c55e" : s.active ? "#2563eb" : "rgba(59,130,246,0.15)"}`,
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            color: (s.done || s.active) ? "#fff" : "#94a3b8",
                                            fontSize: 11, fontWeight: 700, fontFamily: "'Syne',sans-serif",
                                            transition: "all 0.3s"
                                        }}>
                                            {s.done ? <CheckCircleIcon style={{ fontSize: 14 }} /> : i + 1}
                                        </div>
                                        <span style={{
                                            color: s.active ? "#0f172a" : s.done ? "#22c55e" : "#94a3b8",
                                            fontSize: 11, fontWeight: s.active ? 700 : 400, fontFamily: "'DM Sans',sans-serif",
                                            transition: "color 0.3s"
                                        }}>{s.label}</span>
                                    </div>
                                    {i < steps.length - 1 && (
                                        <div style={{
                                            flex: 1, height: 2, borderRadius: 99,
                                            background: i < uiLevel ? "#22c55e" : "rgba(59,130,246,0.12)",
                                            transition: "background 0.3s"
                                        }} />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                        {/* ── STEP 0: Email ── */}
                        {uiLevel === 0 && (
                            <>
                                <h2 style={{ color: "#0f172a", fontSize: 24, fontWeight: 800, fontFamily: "'Syne',sans-serif", margin: "0 0 6px" }}>
                                    Forgot Password?
                                </h2>
                                <p style={{ color: "#64748b", fontSize: 13, margin: "0 0 28px" }}>
                                    Enter the email linked to your account.
                                </p>

                                <form onSubmit={requestOTP} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                                    <div>
                                        <label style={labelStyle}>Email Address</label>
                                        <div style={{ position: "relative" }}>
                                            <MailOutlineIcon style={iconStyle('email')} />
                                            <input type="email" value={emailInput}
                                                onChange={(e) => setEmailInput(e.target.value)}
                                                onFocus={() => setFocused('email')} onBlur={() => setFocused(null)}
                                                placeholder="your@email.com" required style={inputStyle('email')} />
                                        </div>
                                    </div>

                                    <button type="submit" disabled={loading} style={{
                                        width: "100%", borderRadius: 12, padding: "14px 0", border: "none",
                                        background: loading ? "rgba(37,99,235,0.35)" : "linear-gradient(135deg,#0e7490,#0891b2)",
                                        color: "#fff", fontSize: 14, fontWeight: 700,
                                        fontFamily: "'Syne',sans-serif",
                                        cursor: loading ? "not-allowed" : "pointer",
                                        boxShadow: loading ? "none" : "0 6px 20px rgba(8,145,178,0.35)",
                                        display: "flex", alignItems: "center", justifyContent: "center", gap: 8
                                    }}>
                                        {loading ? (
                                            <div style={{
                                                width: 18, height: 18, border: "2.5px solid rgba(255,255,255,0.4)",
                                                borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.8s linear infinite"
                                            }} />
                                        ) : (
                                            <>Send Reset Code <ArrowForwardIcon style={{ fontSize: 16 }} /></>
                                        )}
                                    </button>
                                </form>
                            </>
                        )}

                        {/* ── STEP 1: Reset password ── */}
                        {uiLevel === 1 && (
                            <>
                                <h2 style={{ color: "#0f172a", fontSize: 24, fontWeight: 800, fontFamily: "'Syne',sans-serif", margin: "0 0 6px" }}>
                                    Set New Password
                                </h2>
                                <p style={{ color: "#64748b", fontSize: 13, margin: "0 0 8px" }}>
                                    Check your email inbox for the code we sent to{" "}
                                    <strong style={{ color: "#0f172a" }}>{emailInput}</strong>
                                </p>

                                {/* OTP Countdown */}
                                <div style={{
                                    background: "rgba(8,145,178,0.05)", border: "1px solid rgba(8,145,178,0.15)",
                                    borderRadius: 10, padding: "8px 12px", marginBottom: 20,
                                    display: "flex", alignItems: "center", gap: 8
                                }}>
                                    <MarkEmailReadIcon style={{ color: "#0891b2", fontSize: 16, flexShrink: 0 }} />
                                    <Countdown
                                        zeroPadTime={2}
                                        key={new Date(requestOTPRetObj?.passwordResetCodeTimer)}
                                        date={new Date(requestOTPRetObj?.passwordResetCodeTimer)}
                                        renderer={({ minutes, seconds, completed }) => {
                                            if (completed) {
                                                return (
                                                    <span style={{ color: "#ef4444", fontSize: 12, fontFamily: "'DM Sans',sans-serif" }}>
                                                        Code expired.{" "}
                                                        <button type="button" onClick={() => setUiLevel(0)}
                                                            style={{ background: "none", border: "none", color: "#0891b2", fontSize: 12, fontWeight: 600, cursor: "pointer", padding: 0 }}>
                                                            Request new code
                                                        </button>
                                                    </span>
                                                );
                                            }
                                            return (
                                                <span style={{ color: "#0891b2", fontSize: 12, fontFamily: "'DM Sans',sans-serif" }}>
                                                    Code expires in {minutes}:{seconds}
                                                </span>
                                            );
                                        }}
                                    />
                                </div>

                                <form onSubmit={changePassword} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                                    {/* New password */}
                                    <div>
                                        <label style={labelStyle}>New Password</label>
                                        <div style={{ position: "relative" }}>
                                            <LockOutlinedIcon style={iconStyle('newpw')} />
                                            <input type={showNewPassword ? "text" : "password"} value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                                onFocus={() => setFocused('newpw')} onBlur={() => setFocused(null)}
                                                placeholder="Create new password" required
                                                style={{ ...inputStyle('newpw'), paddingRight: 44 }} />
                                            <button type="button" onClick={() => setShowNewPassword(!showNewPassword)}
                                                style={{
                                                    position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                                                    background: "none", border: "none", cursor: "pointer",
                                                    color: "#94a3b8", display: "flex", alignItems: "center", padding: 0
                                                }}>
                                                {showNewPassword ? <VisibilityOffIcon style={{ fontSize: 18 }} /> : <VisibilityIcon style={{ fontSize: 18 }} />}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Confirm password */}
                                    <div>
                                        <label style={labelStyle}>Confirm Password</label>
                                        <div style={{ position: "relative" }}>
                                            <LockOutlinedIcon style={iconStyle('confpw')} />
                                            <input type={showConfirmPassword ? "text" : "password"} value={confirmNewPassword}
                                                onChange={(e) => setConfirmNewPassword(e.target.value)}
                                                onFocus={() => setFocused('confpw')} onBlur={() => setFocused(null)}
                                                placeholder="Confirm new password" required
                                                style={{
                                                    ...inputStyle('confpw'), paddingRight: 44,
                                                    borderColor: confirmNewPassword && confirmNewPassword !== newPassword
                                                        ? "rgba(239,68,68,0.4)"
                                                        : focused === 'confpw' ? "#2563eb" : "rgba(59,130,246,0.18)"
                                                }} />
                                            <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                style={{
                                                    position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                                                    background: "none", border: "none", cursor: "pointer",
                                                    color: "#94a3b8", display: "flex", alignItems: "center", padding: 0
                                                }}>
                                                {showConfirmPassword ? <VisibilityOffIcon style={{ fontSize: 18 }} /> : <VisibilityIcon style={{ fontSize: 18 }} />}
                                            </button>
                                        </div>
                                        {confirmNewPassword && confirmNewPassword !== newPassword && (
                                            <p style={{ color: "#ef4444", fontSize: 11, margin: "4px 0 0", fontFamily: "'DM Sans',sans-serif" }}>
                                                Passwords do not match
                                            </p>
                                        )}
                                    </div>

                                    {/* Verification code */}
                                    <div>
                                        <label style={labelStyle}>Verification Code</label>
                                        <div style={{ position: "relative" }}>
                                            <KeyIcon style={iconStyle('vcode')} />
                                            <input type="text" value={emailCode}
                                                onChange={(e) => setEmailCode(e.target.value)}
                                                onFocus={() => setFocused('vcode')} onBlur={() => setFocused(null)}
                                                placeholder="Enter the code from your email" required
                                                style={inputStyle('vcode')} />
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                                        <button type="button" onClick={() => setUiLevel(0)} style={{
                                            flex: "0 0 auto", borderRadius: 12, padding: "14px 16px", border: "none",
                                            background: "rgba(59,130,246,0.06)", color: "#64748b",
                                            fontSize: 14, cursor: "pointer",
                                            display: "flex", alignItems: "center", gap: 6
                                        }}>
                                            <ArrowBackIcon style={{ fontSize: 16 }} /> Back
                                        </button>
                                        <button type="submit" disabled={loading} style={{
                                            flex: 1, borderRadius: 12, padding: "14px 0", border: "none",
                                            background: loading ? "rgba(8,145,178,0.35)" : "linear-gradient(135deg,#0e7490,#0891b2)",
                                            color: "#fff", fontSize: 14, fontWeight: 700,
                                            fontFamily: "'Syne',sans-serif",
                                            cursor: loading ? "not-allowed" : "pointer",
                                            boxShadow: loading ? "none" : "0 6px 20px rgba(8,145,178,0.3)",
                                            display: "flex", alignItems: "center", justifyContent: "center", gap: 8
                                        }}>
                                            {loading ? (
                                                <div style={{
                                                    width: 18, height: 18, border: "2.5px solid rgba(255,255,255,0.4)",
                                                    borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.8s linear infinite"
                                                }} />
                                            ) : (
                                                <>Reset Password <ArrowForwardIcon style={{ fontSize: 16 }} /></>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </>
                        )}

                        {/* ── STEP 2: Success ── */}
                        {uiLevel === 2 && (
                            <div style={{ textAlign: "center", padding: "20px 0" }}>
                                <div style={{
                                    width: 72, height: 72, borderRadius: "50%",
                                    background: "rgba(34,197,94,0.1)", border: "2px solid rgba(34,197,94,0.2)",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    margin: "0 auto 20px"
                                }}>
                                    <CheckCircleIcon style={{ color: "#22c55e", fontSize: 36 }} />
                                </div>
                                <h2 style={{ color: "#0f172a", fontSize: 22, fontWeight: 800, fontFamily: "'Syne',sans-serif", margin: "0 0 8px" }}>
                                    Password Reset!
                                </h2>
                                <p style={{ color: "#64748b", fontSize: 13, margin: "0 0 24px", lineHeight: 1.6 }}>
                                    Your password has been reset successfully.<br />
                                    Redirecting you to login in a moment...
                                </p>
                                <div style={{
                                    width: "100%", height: 4, borderRadius: 99,
                                    background: "rgba(34,197,94,0.1)", overflow: "hidden"
                                }}>
                                    <div style={{
                                        height: "100%", background: "linear-gradient(90deg,#22c55e,#16a34a)",
                                        borderRadius: 99, width: "100%",
                                        animation: "progressBar 3s linear forwards"
                                    }} />
                                </div>
                            </div>
                        )}

                        {/* Back to sign in link */}
                        {uiLevel !== 2 && (
                            <div style={{ textAlign: "center", marginTop: 28 }}>
                                <WebLink to="/signin" style={{
                                    color: "#64748b", fontSize: 12, textDecoration: "none",
                                    display: "inline-flex", alignItems: "center", gap: 4
                                }}>
                                    <ArrowBackIcon style={{ fontSize: 14 }} />
                                    Back to Sign In
                                </WebLink>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes progressBar { from { width: 0%; } to { width: 100%; } }
                @media (max-width: 640px) {
                    .auth-left-panel { display: none !important; }
                }
            `}</style>
        </SiteWide>
    );
}

export default ForgetPassword;